import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
} from '@mui/material';
import {
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../config';

interface DashboardStats {
  totalLeads: number;
  leadsHoje: number;
  conversaoRate: number;
  atendimentosAtivos: number;
}

const Home: React.FC = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState<DashboardStats>({
    totalLeads: 0,
    leadsHoje: 0,
    conversaoRate: 0,
    atendimentosAtivos: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Buscar leads
        const leadsResponse = await axios.get(`${API_URL}/leads/`, { headers });
        const totalLeads = leadsResponse.data.length;

        // Buscar atendimentos
        const atendimentosResponse = await axios.get(`${API_URL}/atendimentos/?status=aguardando`, { headers });
        const atendimentosAtivos = atendimentosResponse.data.length;

        // Calcular leads de hoje (simulado)
        const leadsHoje = Math.floor(totalLeads * 0.1); // 10% dos leads totais

        // Calcular taxa de conversão (simulado)
        const conversaoRate = Math.floor(Math.random() * 30) + 10; // Entre 10% e 40%

        setStats({
          totalLeads,
          leadsHoje,
          conversaoRate,
          atendimentosAtivos,
        });
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
      }
    };

    fetchStats();
  }, []);

  const StatCard = ({ title, value, icon, color }: { title: string; value: number | string; icon: React.ReactNode; color: string }) => (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ color, mr: 2 }}>
            {icon}
          </Box>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Box>
        <Typography variant="h4" component="div" sx={{ color }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Dashboard - MedPrime Benefícios
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Bem-vindo, {user?.full_name}! Aqui está o resumo das atividades.
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total de Leads"
            value={stats.totalLeads}
            icon={<PeopleIcon />}
            color="#1976d2"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Leads Hoje"
            value={stats.leadsHoje}
            icon={<TrendingUpIcon />}
            color="#2e7d32"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Taxa de Conversão"
            value={`${stats.conversaoRate}%`}
            icon={<CheckCircleIcon />}
            color="#ed6c02"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Atendimentos Aguardando"
            value={stats.atendimentosAtivos}
            icon={<AssignmentIcon />}
            color="#d32f2f"
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Ações Rápidas
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {user?.role === 'admin' && (
                <Typography variant="body2" color="text.secondary">
                  • Gerenciar usuários do sistema
                </Typography>
              )}
              {user?.role === 'consultor' && (
                <Typography variant="body2" color="text.secondary">
                  • Verificar fila de atendimentos
                </Typography>
              )}
              <Typography variant="body2" color="text.secondary">
                • Visualizar leads cadastrados
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • Acompanhar métricas de conversão
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Status do Sistema
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" color="success.main">
                ✓ Sistema operacional
              </Typography>
              <Typography variant="body2" color="success.main">
                ✓ Chatbot ativo
              </Typography>
              <Typography variant="body2" color="success.main">
                ✓ Banco de dados conectado
              </Typography>
              <Typography variant="body2" color="success.main">
                ✓ API funcionando
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home; 